import { InformationContainer } from '@features/common';
import { AGWRangesTable } from '@features/ranges';
import { DivisionCliente } from '@interfaces/firestore-documents.interfaces';
import { Typography } from '@mui/material';
import useDivisionDetailsStyles from './DivisionDetails.styles';

interface Props {
	active?: boolean;
	data: DivisionCliente;
	onClick?(): void;
}

const DivisionDetails: React.FC<Props> = ({ active, data, onClick }) => {
	const classes = useDivisionDetailsStyles();

	return (
		<InformationContainer
			active={active}
			canClick
			id="division-information-details"
			onClick={onClick}
			style={{ zIndex: 1300, width: '100%', borderRadius: 20 }}
		>
			<div className={classes.root}>
				<div id="division-information-details-agw-guides-range" style={{ width: '25vw' }}>
					<Typography color="rgba(0, 0, 0, 0.6)" fontFamily="Montserrat" fontSize={14}>
						Rango de guías y consecutivo AGW
					</Typography>
					{data.agw_ranges.length > 0 && <AGWRangesTable data={data.agw_ranges} />}
				</div>
				<div id="division-information-details-combos">
					<Typography color="rgba(0, 0, 0, 0.6)" fontFamily="Montserrat" fontSize={14}>
						Combos de servicios
					</Typography>
					<div style={{ marginTop: 4 }}>
						{data.combos.length > 0 ? (
							data.combos
								.sort((a, b) => a.id_combo - b.id_combo)
								.map((c, i) => {
									if (c.estado) {
										return (
											<Typography
												fontFamily="Montserrat"
												fontSize={14}
												fontWeight={700}
												id={`division-${data.codigo_div}-information-combos-${c.id_combo}`}
												key={`division-${data.codigo_div}-information-combos-${c.id_combo}-${i}`}
											>
												{c.id_combo}.{' '}
												<Typography
													component="span"
													fontSize={14}
													fontWeight="normal"
												>
													{c.nombre_combo}
												</Typography>
											</Typography>
										);
									}
								})
						) : (
							<Typography fontFamily="Montserrat" fontSize={14}>
								No hay combos asociados
							</Typography>
						)}
					</div>
				</div>
				<div id="division-information-details-notification">
					<Typography color="rgba(0, 0, 0, 0.6)" fontFamily="Montserrat" fontSize={14}>
						Notificación remitente
					</Typography>
					<Typography
						color="#1A1233"
						fontFamily="Montserrat"
						fontSize={14}
						fontWeight={600}
						style={{ marginTop: 4 }}
					>
						{data.notificacion_remitente ? 'Activo' : 'Inactivo'}
					</Typography>
				</div>
			</div>
		</InformationContainer>
	);
};

export default DivisionDetails;
